import { useEffect, useState } from "react";
import Select from 'react-select';
import { FormControl, InputLabel, createTheme, ThemeProvider, Snackbar, Alert, Modal, Box, CircularProgress } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { WhiteInput } from "../../components/Inputs/InputText";
import styles from "./SolicitacaoFiscalizacao.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import ptBR from "date-fns/locale/pt-BR";
import { SearchFieldStyles } from "../../components/Searchfields/SearchFieldStyles";
import { OpcoesSituacaoSolicFiscalizacao } from "../../components/Combobox/SituacaoSolicFiscalizacao";
import { SearchFieldStylesFiltro } from "../../components/Searchfields/SearchFieldStylesFiltro";
import { OpcoesPeriodoDatas } from "../../components/Combobox/PeriodoDatas";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { BlueHoverButton } from "../../components/Inputs/BlueHoverButton";
import Lista from "../../components/Lista";
import { columnsSolicitacaoFiscalizacao } from "./Lista";
import Popup from "../../components/Popup";
import servSolicitacaoFiscalizacao from "../../services/login/servSolicitacaoFiscalizacao";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ErrorHandling } from "../../components/Errors/Errors";
import { logout } from "../../state/slices/userSlice";
import servFileIni from "../../services/login/servFileIni";
import { retornaDatasCfeTipoPeriodo } from "../../infra/utils/RetornaDatasCfeTipoPeriodo";
import Cadastro from "./Cadastro";
import Analise from "./Analise";
import servParam from "../../services/login/servParam";
import servSolicitacaoFiscalizacaoDocs from "../../services/login/servSolicitacaoFiscalizacaoDocs";
import SolicitarCancelamento from "./SolicitarCancelamento";
import { setCurrentSolicitacaoFiscalizacao } from "../../state/slices/analisesSlice";
import { newTab, setTabFromNewIndex } from "../../state/slices/tabsSlice";
import { style as modalStyle } from "../../components/Loading/Loading";
import ResultadoAnalise from "./ResultadoAnalise";

const SolicitacaoFiscalizacao = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector(state => state.user);

  const [filtro, setFiltro] = useState("");
  const [tipoPeriodo, setTipoPeriodo] = useState({ value: 8, label: 'Este mês' });
  const [filtroCodigoSolicitacaoFiscalizacao, setFiltroCodigoSolicitacaoFiscalizacao] = useState("");
  const [situacaoSolicFiscalizacao, setSituacaoSolicFiscalizacao] = useState([]);
  const [dataInicialFiltro, setDataInicialFiltro] = useState(new Date());
  const [tipoDataFiltro, setTipoDataFiltro] = useState("data-cadastro");
  const [dataFinalFiltro, setDataFinalFiltro] = useState(new Date());
  const [solicitacoes, setSolicitacoes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [openError, setOpenError] = useState(false);
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [openCadastro, setOpenCadastro] = useState(false);
  const [ehNovoCadastro, setEhNovoCadastro] = useState(false);
  const [openAnalise, setOpenAnalise] = useState(false);
  const [openCancelamento, setOpenCancelamento] = useState(false);
  const [severity, setSeverity] = useState("warning");
  const [dataResultado, setDataResultado] = useState(null);
  const [openResultado, setOpenResultado] = useState(false);

  useEffect(() => {
    const recuperarDados = async (filtroDatas) => {
      try {
        setIsLoading(true);

        let dados;

        if (!filtroDatas) {
          dados = await servSolicitacaoFiscalizacao.ListarCFiltros(user.codigoUsuario, "");
        } else {
          let arraySituacoes = [];

          arraySituacoes = situacaoSolicFiscalizacao.map((item) => item.value);

          dados = await servSolicitacaoFiscalizacao.listarCfeSituacaoOuDatas(user.codigoUsuario, filtro, filtroCodigoSolicitacaoFiscalizacao, arraySituacoes, tipoDataFiltro, filtroDatas.dataInicial, filtroDatas.dataFinal);
        }

        let content = dados?.Content;

        if (dados?.Content.length === 0) {
          return setIsLoading(false);
        }

        content && content.map((solicitacao) => {
          return solicitacao.id = solicitacao.Id
        });

        setSolicitacoes(content);

        setIsLoading(false);
      } catch (err) {
        setIsLoading(false);

        return ErrorHandling(
          err?.response?.status,
          err?.Message,
          setOpenError,
          setErrorMessage,
          dispatch,
          logout,
          navigate,
          err?.response?.data?.Message
        )
      }
    }

    const recuperarUltimoTipoPeriodoDefinido = async () => {
      try {
        let dto = {
          CodigoUsuario: user.codigoUsuario.toString(),
          CodigoSecao: "TIPO_PERIODO_P3",
          Chave: "IDTIPOPERIODOSOLICFISCALIZACAO",
          Conteudo: ""
        };

        let response = await servFileIni.Recuperar(dto);
        let novasDatas;

        if (response.Content.trim() !== "") {
          let conteudo = Number(response.Content);
          let labelTipoPeriodo = OpcoesPeriodoDatas.find((periodo) => periodo.value === conteudo).label;

          await setarTipoPeriodoERedefinirDatas({ value: conteudo, label: labelTipoPeriodo });
          novasDatas = retornaDatasCfeTipoPeriodo(conteudo);
        } else {
          await setarTipoPeriodoERedefinirDatas({ value: 8, label: "Este mês" });
          novasDatas = retornaDatasCfeTipoPeriodo(8);
        }

        if (solicitacoes.length === 0) {
          recuperarDados(novasDatas);
        }

        setIsLoading(false);

      } catch (err) {
        setIsLoading(false);

        return ErrorHandling(
          err?.response?.status,
          err?.Message,
          setOpenError,
          setErrorMessage,
          dispatch,
          logout,
          navigate,
          err?.response?.data?.Message
        );
      }
    }

    recuperarUltimoTipoPeriodoDefinido();
  }, []);

  const theme = createTheme({
    components: {
      MuiIconButton: {
        styleOverrides: {
          sizeMedium: {
            color: "#d2d4d2"
          }
        }
      }
    }
  });

  const onClickPesquisar = async () => {
    try {
      setIsLoading(true);
      let dados;

      if (situacaoSolicFiscalizacao.length === 0 &&
        (!dataInicialFiltro || dataInicialFiltro.toLocaleDateString() === "") &&
        (!dataFinalFiltro || dataFinalFiltro.toLocaleDateString() === "")) {
        dados = await servSolicitacaoFiscalizacao.ListarCFiltros(user.codigoUsuario, filtro);
      } else {
        let arraySituacoes = [];

        arraySituacoes = situacaoSolicFiscalizacao.map((item) => item.value);

        dados = await servSolicitacaoFiscalizacao.listarCfeSituacaoOuDatas(user.codigoUsuario, filtro, filtroCodigoSolicitacaoFiscalizacao, arraySituacoes, tipoDataFiltro, dataInicialFiltro, dataFinalFiltro);
      }

      let content = dados?.Content;

      content && content.map((solicitacao) => {
        return solicitacao.id = solicitacao.Id
      });

      setIsLoading(false);
      setRecordForEdit(null);
      setSolicitacoes(content);

      if (content.length === 0) {
        setErrorMessage("Não foram encontrados registros para sua pesquisa");
        setOpenError(true);
      }

    } catch (err) {
      setIsLoading(false);

      return ErrorHandling(
        err?.response?.status,
        err?.Message,
        setOpenError,
        setErrorMessage,
        dispatch,
        logout,
        navigate,
        err?.response?.data?.Message);
    }
  }

  const handleTipoDataFiltro = (event) => {
    event.preventDefault();

    setTipoDataFiltro(event.target.value)
  }

  const abrirSolicitacaoExistente = () => {
    setEhNovoCadastro(false);
    setOpenCadastro(true);
  }

  const setarTipoPeriodoERedefinirDatas = async (tipoPeriodo) => {
    try {
      setTipoPeriodo(tipoPeriodo);

      let datasCalculadas = retornaDatasCfeTipoPeriodo(tipoPeriodo?.value);
      setDataInicialFiltro(datasCalculadas.dataInicial);
      setDataFinalFiltro(datasCalculadas.dataFinal);

      let dto = {
        Chave: "IDTIPOPERIODOSOLICFISCALIZACAO",
        Conteudo: tipoPeriodo.value.toString(),
        CodigoSecao: "TIPO_PERIODO_P3",
        CodigoUsuario: user.codigoUsuario.toString()
      };

      await servFileIni.Inserir(dto);
    } catch (err) {
      setIsLoading(false);
      setErrorMessage("Erro ao salvar tipo de período. Tente novamente.");
      setOpenError(true);
      return;
    }
  }

  const adicionarNovaSolicitacao = () => {
    setRecordForEdit(null);
    setEhNovoCadastro(true);
    setOpenCadastro(true);
  }

  const solicitarAnalise = async () => {
    if (recordForEdit === null) {
      setErrorMessage("É necessário selecionar um registro");
      return setOpenError(true);
    }

    const situacoesHomologaveis = [0, 2];

    if (!situacoesHomologaveis.includes(recordForEdit?.row?.SituacaoFiscalizacao)
      && !situacoesHomologaveis.includes(recordForEdit?.SituacaoFiscalizacao)) {
      setErrorMessage("Só é possível solicitar análise de consultas com situação em digitação ou revisão");
      return setOpenError(true);
    }

    try {
      setIsLoading(true);

      const idSolicFiscalizacao = recordForEdit?.row?.Id || recordForEdit?.Id;

      const [docsObrigatorios, docsVinculados] = await Promise.all([
        servParam.RecuperarDocumentosObrigatorios(13),
        servSolicitacaoFiscalizacaoDocs.listar(idSolicFiscalizacao)
      ]);

      const docsAtualizados = docsObrigatorios.Content.map((doc) => {
        const documentoVinculado = docsVinculados.Content?.find(
          (docVinculado) =>
            doc.Id == docVinculado.CodigoConfiguracaoDoc &&
            doc.CodigoClassificacaoDoc == docVinculado.CodigoClassificacaoDoc
        );

        if (documentoVinculado) {
          return {
            ...doc,
            CodigoDocumento: documentoVinculado.CodigoDocumento
          };
        }

        return doc;
      });

      const docsObrigatoriosPendentes = docsAtualizados.filter(
        doc => doc.Obrigatorio === 1 && !doc.CodigoDocumento
      );

      setIsLoading(false);

      if (docsObrigatoriosPendentes.length > 0) {
        const nomesDocs = docsObrigatoriosPendentes.map(doc => doc.Descricao).join(', ');
        setSeverity("warning");
        setErrorMessage(`Existem documentos obrigatórios pendentes: ${nomesDocs}`);
        return setOpenError(true);
      }

      return setOpenAnalise(true);
    } catch (err) {
      setIsLoading(false);
      setErrorMessage(err?.response?.data?.Message || "Erro ao verificar documentos obrigatórios.");
      return setOpenError(true);
    }
  }

  const visualizarAnalisesAnteriores = () => {
    if (recordForEdit === null) {
      setErrorMessage("É necessário selecionar um registro");
      return setOpenError(true);
    }

    const situacaoSemAnalise = 0;

    if (recordForEdit?.row?.SituacaoFiscalizacao === situacaoSemAnalise
      || recordForEdit?.SituacaoFiscalizacao === situacaoSemAnalise) {
      setErrorMessage("A solicitação ainda não foi enviada para análise, portanto não possui análises realizadas");
      return setOpenError(true);
    }

    const listaSolicitacao = {
      Nome: "Análises da solicitação de fiscalização",
      Aba: 14
    }

    let id = recordForEdit?.row?.Id || recordForEdit?.Id;

    dispatch(newTab(listaSolicitacao));
    dispatch(setTabFromNewIndex(listaSolicitacao.Aba));
    dispatch(setCurrentSolicitacaoFiscalizacao(id));
  }

  const solicitarCancelamento = async () => {
    if (recordForEdit === null) {
      setErrorMessage("É necessário selecionar um registro")
      return setOpenError(true);
    }

    const situacoesCancelaveis = [0, 1, 2];

    if (situacoesCancelaveis.includes(recordForEdit?.row?.SituacaoFiscalizacao) || situacoesCancelaveis.includes(recordForEdit?.SituacaoFiscalizacao)) {
      return setOpenCancelamento(true);
    }

    setSeverity("warning");
    setErrorMessage("Só é possível cancelar solicitação de fiscalização com situação em digitação, aguardando análise e revisar solicitação");
    return setOpenError(true);
  }

  const handleCloseError = (event, reason) => {
    if (reason === 'clickaway') {
      setOpenError(false);
    }

    setOpenError(false);
  }

  const onClickAbrirResultadoAnalise = async () => {
    if (recordForEdit === null) {
      setErrorMessage("É necessário selecionar um registro");
      return setOpenError(true);
    }

    const response = await servSolicitacaoFiscalizacao.ListarSolicitacoesFiscalizacaoAnalise(recordForEdit?.Id, "");

    if (response?.Content?.length === 0) {
      setErrorMessage("Não há análises para esta solicitação de compartilhamento.");
      return setOpenError(true);
    }

    const analise = response.Content.reduce((prev, current) => (prev.Analise > current.Analise) ? prev : current);

    setDataResultado(analise);
    setOpenResultado(true);
  }

  return (
    <div className={styles.solicitacaoContainer}>
      <div className={styles.solicitacaoFiltros}>
        <FormControl>
          <InputLabel shrink htmlFor="pesquisa-obs" style={{ color: "#B8B8B8", marginLeft: "10px" }} >Pesquisa geral<FontAwesomeIcon title="Este campo pesquisa por: código da solicitação de compartilhamento e protocolo." style={{ marginLeft: "10px", width: "15px", height: "15px", cursor: "pointer" }} icon={faQuestionCircle} /></InputLabel>
          <WhiteInput value={filtro} onChange={(e) => setFiltro(e.target.value)} placeholder="Pesquisa" id="pesquisa-obs" sx={{ width: "500px", margin: '0px 18px' }} />
        </FormControl>
      </div>

      <div className={styles.solicitacaoFiltros} style={{ marginTop: "20px" }}>
        <FormControl>
          <InputLabel shrink style={{ color: "#B8B8B8", marginLeft: "10px" }} >Solic. de compartilhamento</InputLabel>
          <WhiteInput value={filtroCodigoSolicitacaoFiscalizacao} onChange={(e) => setFiltroCodigoSolicitacaoFiscalizacao(e.target.value)} placeholder="Solic. de compartilhamento" id="pesquisa-codigo-solicitacao-fiscalizacao" sx={{ width: "200px", margin: '0px 18px' }} />
        </FormControl>
        <FormControl variant="outlined" sx={{ width: "450px", marginRight: "20px" }}>
          <InputLabel htmlFor="pesquisa-obs-situacao" shrink style={{ color: "#B8B8B8" }}>
            Situação
          </InputLabel>
          <Select
            isMulti={true}
            value={situacaoSolicFiscalizacao}
            onChange={value => setSituacaoSolicFiscalizacao(value)}
            options={OpcoesSituacaoSolicFiscalizacao}
            styles={SearchFieldStyles}
            placeholder="Situação"
          />
        </FormControl>
      </div>

      <div className={styles.solicitacaoFiltros}>
        <FormControl variant="outlined">
          <InputLabel htmlFor="data-solicfiscalizacao" shrink style={{ color: "#B8B8B8", marginTop: "20px", marginLeft: "10px" }} >
            <select className={styles.tipoDataFiltroConsulta} name="tipo-data" id="tipo-data" value={tipoDataFiltro} onChange={handleTipoDataFiltro}>
              <optgroup>
                <option value="data-cadastro" selected>Data cadastro</option>
                <option value="data-apresentacao">Data apresentação</option>
                <option value="data-prazo-analise">Prazo análise</option>
                <option value="data-inicio-instal">Data início instalação</option>
                <option value="data-termino-instal">Data término instalação</option>
                <option value="data-conslusao">Data conclusão</option>
              </optgroup>
            </select>
          </InputLabel>
          <div className={styles.solicitacaoFiscalizacaoDatas}>
            <Select
              value={tipoPeriodo}
              onChange={(e) => setarTipoPeriodoERedefinirDatas(e)}
              options={OpcoesPeriodoDatas}
              styles={SearchFieldStylesFiltro}
              placeholder="Período"
            />
            <ThemeProvider theme={theme}>
              <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR} localeText={{ todayButtonLabel: "Hoje" }}>
                <DatePicker
                  fullWidth
                  inputFormat="dd/MM/yyyy"
                  value={dataInicialFiltro}
                  onChange={(e) => setDataInicialFiltro(e)}
                  renderInput={({ inputRef, inputProps, InputProps }) => (
                    <>
                      <WhiteInput ref={inputRef}  {...inputProps} sx={{ color: "#707070" }} />
                      <span style={{ position: "absolute", top: 58, right: 250, color: "white", svg: "white", input: "white", label: "white" }}>
                        {InputProps?.endAdornment}
                      </span>
                    </>
                  )}
                  componentsProps={{
                    actionBar: {
                      actions: ["today"]
                    }
                  }}
                />
              </LocalizationProvider>
            </ThemeProvider>
            <span style={{ color: "whitesmoke", margin: "9px 5px" }}>-</span>
            <ThemeProvider theme={theme}>
              <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR} localeText={{ todayButtonLabel: "Hoje" }}>
                <DatePicker
                  fullWidth
                  inputFormat="dd/MM/yyyy"
                  value={dataFinalFiltro}
                  onChange={(e) => setDataFinalFiltro(e)}
                  renderInput={({ inputRef, inputProps, InputProps }) => (
                    <>
                      <WhiteInput ref={inputRef}  {...inputProps} sx={{ color: "#707070" }} />
                      <span style={{ position: "absolute", top: 58, right: 30, color: "white", svg: "white", input: "white", label: "white" }}>
                        {InputProps?.endAdornment}
                      </span>
                    </>
                  )}
                  componentsProps={{
                    actionBar: {
                      actions: ["today"]
                    }
                  }}
                />
              </LocalizationProvider>
            </ThemeProvider>
          </div>
        </FormControl>
        <BlueHoverButton variant="contained" onClick={onClickPesquisar} style={{ marginTop: "16.5px" }}>
          Pesquisar
        </BlueHoverButton>
      </div>

      <div className={styles.solicitacaoBotoes}>
        <BlueHoverButton variant="contained" onClick={adicionarNovaSolicitacao}>Nova solicitação</BlueHoverButton>
        <BlueHoverButton variant="contained" onClick={solicitarAnalise}>Enviar para análise</BlueHoverButton>
        <BlueHoverButton variant="contained" onClick={visualizarAnalisesAnteriores}>Análises</BlueHoverButton>
        <BlueHoverButton variant="contained" onClick={onClickAbrirResultadoAnalise}>Resultado da análise</BlueHoverButton>
        <BlueHoverButton variant="contained" onClick={solicitarCancelamento}>Cancelar</BlueHoverButton>
      </div>

      <div className={styles.solicitacaoLista}>
        <Lista
          columns={columnsSolicitacaoFiscalizacao}
          rows={solicitacoes}
          onDblClick={abrirSolicitacaoExistente}
          setSelectedData={setRecordForEdit}
          hideFooter={false}
          autoHeight={false}
        />
      </div>

      <Popup
        title="Solicitação de fiscalização"
        openPopup={openCadastro}
        setOpenPopup={setOpenCadastro}
        novoCadastro={ehNovoCadastro}
        setNovoCadastro={setEhNovoCadastro}
        minWidth = "925px"
      >
        <Cadastro
          pesquisar={onClickPesquisar}
          recordForEdit={recordForEdit}
          setOpen={setOpenCadastro}
          novoCadastro={ehNovoCadastro}
          setEhNovoCadastro={setEhNovoCadastro}
        />
      </Popup>

      <Popup title="Enviar para análise" openPopup={openAnalise} setOpenPopup={setOpenAnalise} minHeight="100px" >
        <Analise
          pesquisar={onClickPesquisar}
          record={recordForEdit}
          setOpen={setOpenAnalise}
        />
      </Popup>

      <Popup title="Solicitar cancelamento" openPopup={openCancelamento} setOpenPopup={setOpenCancelamento} minHeight="100px">
        <SolicitarCancelamento
          setOpenPopup={setOpenCancelamento}
          recordForEdit={recordForEdit}
          pesquisar={onClickPesquisar}
        />
      </Popup>

      <Popup title="Resultado da Análise" openPopup={openResultado} setOpenPopup={setOpenResultado} minHeight="100px">
        <ResultadoAnalise
          record={dataResultado}
          recordForView={dataResultado}
          setIsLoading={setIsLoading}
        />
      </Popup>

      <Modal open={isLoading} >
        <Box style={modalStyle} >
          <CircularProgress color="inherit" />
        </Box>
      </Modal>

      <Snackbar open={openError} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={6000} onClose={handleCloseError}>
        <Alert onClose={handleCloseError} severity={severity} sx={{ width: '100%' }}>
          {errorMessage}
        </Alert>
      </Snackbar>
    </div>
  )
}

export { SolicitacaoFiscalizacao };